import { AppSnackbar } from '../services/AppSnackbar';

export const parseMassFieldValue = (raw: string | undefined | null): number => {
  if (raw == null || raw === '') return 0;
  const n = Number.parseFloat(String(raw).replace(/,/g, ''));
  if (!Number.isFinite(n) || n <= 0) return 0;
  return n;
};

export const shouldRestorePaidFloor = (
  updating: boolean,
  paid: number,
  current: number,
): boolean => updating && paid > 0 && current < paid;

export const showPaidLineCannotRemove = () => {
  AppSnackbar.show(
    'This item is fully or partially paid. It cannot be removed. Cancel the order instead.',
    'warning',
    { durationMs: 5000 },
  );
};

/** Returns true if current was below paid and onRestore ran. */
export const applyPaidFloorIfNeeded = ({
  updating,
  paid,
  current,
  onRestore,
}: {
  updating: boolean;
  paid: number;
  current: number;
  onRestore: (paid: number) => void;
}): boolean => {
  if (!shouldRestorePaidFloor(updating, paid, current)) return false;
  onRestore(paid);
  showPaidLineCannotRemove();
  return true;
};
